import { useEffect, useState } from "react";

/**
 * Handy oder nicht - EINE Grenze fuer die ganze Anwendung.
 *
 * 768 Pixel ist Tailwinds "md": darunter zeigt der Rahmen die Leiste unten
 * und die Handy-Fassungen der Seiten (Wallboard), darueber Menue links und
 * die gewohnten Seiten. Entscheidend ist die Fensterbreite, nicht das Geraet:
 * Ein iPad hochkant ist ein Handy, quer ein Rechner, und am Schreibtisch
 * laesst sich die Handy-Ansicht durch Schmalziehen des Fensters pruefen.
 *
 * Wer im Code "ist das ein Handy?" fragt, nimmt diesen Hook - keine eigene
 * Breite, keine Geraetekennung. Sonst zeigt eine Seite die Leiste, die
 * andere nicht, und nichts passt zusammen.
 */
export const HANDY_GRENZE_PX = 768;
const FRAGE = `(max-width: ${HANDY_GRENZE_PX - 1}px)`;

export default function useHandy() {
  const [handy, setHandy] = useState(() => {
    try { return window.matchMedia(FRAGE).matches; } catch { return false; }
  });
  useEffect(() => {
    let mq;
    try { mq = window.matchMedia(FRAGE); } catch { return undefined; }
    const h = (e) => setHandy(e.matches);
    if (mq.addEventListener) mq.addEventListener("change", h);
    else mq.addListener(h);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", h);
      else mq.removeListener(h);
    };
  }, []);
  return handy;
}
